import React, { useEffect, useMemo, useState } from "react";
import styles from "../Block.module.css";
import { getParentsIdsList, isNonEmptyArray } from "../../../../../utils";
import { CategoryList } from "../../../../lists";

const getChildrenIdsList = (category) => {
	if (!category) {
		return [];
	}
	if (!Array.isArray(category.subThematic)) {
		return [category.id];
	}
	return [category.id, ...category.subThematic.map((cat) => getChildrenIdsList(cat))].flat();
};

const CategoryBlock = ({ elements, identifier, isEditing = false, onChange, title = "", values = [] }) => {
	const [toAdd, setToAdd] = useState([]);
	const [toDelete, setToDelete] = useState([]);
	const defaultCheckedIds = useMemo(() => values.map((value) => value.id), [values]);
	useEffect(() => {
		setToAdd([]);
		setToDelete([]);
	}, [isEditing]);
	const handleCheck = (isChecked, element) => {
		let tempToAdd = [...toAdd];
		let tempToDelete = [...toDelete];
		if (isChecked) {
			const parents = getParentsIdsList(elements, element);
			tempToAdd = [
				...tempToAdd,
				...parents.filter((id) => !defaultCheckedIds.includes(id) && !tempToAdd.includes(id)),
			];
			tempToDelete = tempToDelete.filter((id) => parents.indexOf(id) === -1);
		} else {
			const children = getChildrenIdsList(element);
			tempToDelete = [
				...tempToDelete,
				...children.filter((id) => defaultCheckedIds.includes(id) && !tempToDelete.includes(id)),
			];
			tempToAdd = tempToAdd.filter((id) => children.indexOf(id) === -1);
		}
		setToAdd(tempToAdd);
		setToDelete(tempToDelete);
		onChange(identifier, tempToAdd, tempToDelete);
	};

	return (
		<div className={styles.innerContainer}>
			<div className={styles.title}>{title}</div>
			{(!isEditing && (
				<div className={styles.chips}>
					{(isNonEmptyArray(values) &&
						values.map((value) => (
							<div key={value.id} className={styles.chip}>
								{value.name}
							</div>
						))) ||
						"-"}
				</div>
			)) || (
				<div>
					<CategoryList
						editable
						categoryList={elements}
						checkedIds={[...defaultCheckedIds, ...toAdd].filter((id) => !toDelete.includes(id))}
						onCheck={handleCheck}
					/>
				</div>
			)}
		</div>
	);
};

export default CategoryBlock;
